module.exports = __webpack_public_path__ + "img/private-napolimania-meat-1.50bc4d97.jpg";